export enum MODULE_RESOURCE {
    Customers = 'customers',
    Orders = 'inventory-orders',
    RelatedOrders = 'inventory-related-orders',
    CustomerInventories = 'inventory-customer-inventories',
    CustomerInventoryOrderedStatuses = 'inventory-customer-inventory-ordered-statuses',
    ProductVariants = 'inventory-product-variants',
    Products = 'inventory-products',
    Brokers = 'inventory-brokers',
    ShippingOptions = 'inventory-shipping-options',
}


export type MedusaResources = typeof MODULE_RESOURCE[keyof typeof MODULE_RESOURCE]
    // | 'inventory-orders'
    // | 'inventory-customer-inventories'
    // | 'inventory-product-variants'
    // | 'inventory-products'
    // | 'inventory-shipping-options'


